/**
 * Test utility for AI Service integration
 * This file can be used to test the AI service via Supabase Edge Functions independently
 */

import aiService from '../lib/aiService.js'

export const testAIServiceConnection = async () => {
  console.log('Testing AI Service connection via Supabase Edge Function...')
  
  try {
    const testPrompt = "Create a short story about a detective solving a mystery"
    const testTitle = "Test Project"
    
    console.log('Sending test request to AI Service...')
    const result = await aiService.generateSlideContent(testPrompt, testTitle, 'prompt')
    
    console.log('AI Service response:', result)
    
    if (result && result.title) {
      console.log('✅ AI Service integration working!')
      return { success: true, data: result }
    } else {
      console.log('⚠️ AI Service returned unexpected format')
      return { success: false, error: 'Unexpected response format' }
    }
  } catch (error) {
    console.error('❌ AI Service test failed:', error)
    return { success: false, error: error.message }
  }
}

export const testAssistantResponse = async () => {
  console.log('Testing AI Assistant response...')
  
  try {
    const testMessage = "How can I improve the typography on my slide?"
    const mockSlide = {
      id: 'test-slide',
      type: 'content',
      elements: [
        {
          id: 'test-text',
          type: 'text',
          content: 'Test Slide Title',
          style: { fontSize: '24px', color: '#000000' }
        }
      ]
    }
    
    console.log('Sending test assistant request...')
    const result = await aiService.generateAssistantResponse(testMessage, mockSlide)
    
    console.log('Assistant response:', result)
    
    if (result && result.content) {
      console.log('✅ AI Assistant integration working!')
      return { success: true, data: result }
    } else {
      console.log('⚠️ Assistant returned unexpected format')
      return { success: false, error: 'Unexpected response format' }
    }
  } catch (error) {
    console.error('❌ Assistant test failed:', error)
    return { success: false, error: error.message }
  }
}

// Function to run all tests
export const runAllTests = async () => {
  console.log('🚀 Running AI Service integration tests...')
  
  const results = {}
  
  results.connectionTest = await testAIServiceConnection()
  results.assistantTest = await testAssistantResponse()
  
  console.log('📊 Test Results Summary:')
  console.log('Connection Test:', results.connectionTest.success ? '✅ PASS' : '❌ FAIL')
  console.log('Assistant Test:', results.assistantTest.success ? '✅ PASS' : '❌ FAIL')
  
  if (!results.connectionTest.success || !results.assistantTest.success) {
    console.log('\n⚠️ Some tests failed. Check that your OPENROUTER_API_KEY is set in Supabase secrets.')
    console.log('The app will fall back to mock responses if the API key is not configured.')
  }
  
  return results
}

// Make tests available globally for browser console testing
if (typeof window !== 'undefined') {
  window.testAI = {
    testConnection: testAIServiceConnection,
    testAssistant: testAssistantResponse,
    runAll: runAllTests
  }
  
  console.log('🔧 AI Service tests available in browser console:')
  console.log('- window.testAI.testConnection()')
  console.log('- window.testAI.testAssistant()')
  console.log('- window.testAI.runAll()')
}
